import { QuoteLeadAnalyticsData, QuoteLeadOrigin, StudentDetails } from '@lx/quote-tool/shared/types';
import { AnalyticsService } from '@lx/quote-tool/shared/services';
import { QuoteToolLiteState } from '../store';

export interface BaseLeadPayload {
  analyticsData: QuoteLeadAnalyticsData;
  leadUserData: StudentDetails;
  formOrigin?: QuoteLeadOrigin;
}

export interface BaseLeadPayloadDeps {
  analyticsService: AnalyticsService;
  locale: string;
}

export function withBaseLeadPayload<T extends BaseLeadPayloadDeps>({ analyticsService, locale }: T) {
  return {
    buildBaseLeadPayload: (state: Partial<QuoteToolLiteState>, formOrigin?: QuoteLeadOrigin): BaseLeadPayload => {
      const analyticsData = analyticsService.getQuoteLeadAnalyticsData();

      const leadUserData = {
        ...state.studentDetails,
        websiteLanguage: locale,
      };

      return {
        analyticsData,
        leadUserData,
        formOrigin: formOrigin ?? undefined,
      };
    },
  };
}
